import { FuelButton } from '@frete.com/fuel-react';
import useMenuEvents from 'hooks/events/useMenuEvents';
import { useAddContact, useRemoveContact } from 'hooks/queries/useContactListQuery';
import { useGetTruckerQueriesData } from 'hooks/useGetTruckerQueriesData';
import React, { FC, useEffect, useState } from 'react';
import * as Styled from './styled';
import RemoveContactModal from './RemoveContactModal';

const ContactListButton: FC = () => {
  const { truckerData } = useGetTruckerQueriesData();

  const { isPending: isLoadingAdd, mutate: mutateAdd, error: errorAdd } = useAddContact(truckerData?.trucker?.uuid);
  const {
    isPending: isLoadingRemove,
    mutate: mutateRemove,
    error: errorRemove,
  } = useRemoveContact(truckerData?.trucker?.uuid);

  const { addRemoveFromContactListEvent, modalConfirmRemoveFromContactListEvent } = useMenuEvents();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDialogState = () => setIsModalOpen((state) => !state);

  const handleConfirmRemove = (event: React.MouseEvent) => {
    modalConfirmRemoveFromContactListEvent('confirmed', truckerData, event);
    handleDialogState();
    mutateRemove();
  };

  const handleCancelRemove = (event: React.MouseEvent) => {
    modalConfirmRemoveFromContactListEvent('canceled', truckerData, event);
    handleDialogState();
  };

  const handleAddRemoveUserFromContactList = (event: React.MouseEvent) => {
    if (truckerData?.trucker?.inContactList) {
      handleDialogState();
      addRemoveFromContactListEvent('exclude', truckerData, event);
      return;
    }
    addRemoveFromContactListEvent('add', truckerData, event);
    mutateAdd();
  };

  useEffect(() => {
    if (errorAdd) {
      addRemoveFromContactListEvent('error', truckerData);
    }

    if (errorRemove) {
      modalConfirmRemoveFromContactListEvent('error', truckerData);
    }
  }, [errorRemove, errorAdd]);

  return (
    <>
      <Styled.ButtonWrapper>
        {truckerData?.trucker?.inContactList && <Styled.ButtonBackground />}
        <FuelButton
          data-testid="contact-list-button"
          variant="secondary"
          onlyIcon={!truckerData?.trucker?.inContactList}
          trailingIcon={truckerData?.trucker?.inContactList ? '' : 'add-user'}
          onClick={(event) => handleAddRemoveUserFromContactList(event)}
          size="small"
          isLoading={isLoadingAdd || isLoadingRemove}
          disabled={isLoadingAdd || isLoadingRemove}
        >
          Meu contato
        </FuelButton>
      </Styled.ButtonWrapper>
      {isModalOpen && (
        <RemoveContactModal
          isModalOpen={isModalOpen}
          handleCancelRemove={handleCancelRemove}
          handleConfirmRemove={handleConfirmRemove}
          handleDialogState={handleDialogState}
        />
      )}
    </>
  );
};

export default ContactListButton;
